module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_02_american-village-46b872584a4ff548afee39277d223ebe.jpg";